// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__sjnVa","friendPhoto":"Sidebar_friendPhoto__IdNTh","createEvent":"Sidebar_createEvent__8TYV_"};